import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { userInputs } from '../../inputs/user.inputs';

const form: FormInput[] = [
  userInputs.email,
  userInputs.name,
  userInputs.password,
  userInputs.terms,
  userInputs.isAccepted,
];

export const consumerRegisterForm = createForm(form);

export type ConsumerRegisterFormBody = {
  email: string;
  name: string;
  password: string;
  isAccepted: boolean;
};
